import { useEffect, useRef } from "react";
import jwt from "jsonwebtoken";
import tokCheck from "./_Utils/utilsCodes"
import MyDateTime from "./DTechComp/MyDateTime";
import ConnUrls from "./Connections/ConnectURL";
import { isFreshPageLoad } from "./DTechComp/NavigationTracker";
import { openViaApp } from "./DTechComp/AppPromo/appEnv";


const checkToken = async (toeknToCheck) => {

    let theUsr = await tokCheck.checkToken(toeknToCheck);
    return theUsr;

}

const connCheck = async () => {
    const usrtoken = localStorage.getItem('usrtoken');

    if (usrtoken) {
        const user = jwt.decode(usrtoken);

        let usr = await checkToken(usrtoken);

        if (usr.user != null) {
            return usr;
        }
        else {
            localStorage.removeItem('usrtoken');
            return null;

            // goLogin();
        }

    }
    else {
        return null;
    }
}

// const goLogin = () => {
//     if (!window.location.href.includes('/LoginPage') && !window.location.href.includes('/resPass')) {
//         return window.location.href = '/LoginPage'
//     }

// }


const sortAsc = (arr, field) => {
    return arr.sort((a, b) => {
        if (a[field] > b[field]) { return 1; }
        if (b[field] > a[field]) { return -1; }
        return 0;
    })
}

const setSHuffledRandom = (rests, lstBack) => {
    // let filt = rests.filter(itm => !itm.random)
    // let noMe = go.filter(itm => itm.random)

    let randomIndex = Math.floor(Math.random() * rests.length);
    lstBack.push(rests[randomIndex]);
    rests.splice(randomIndex, 1);
    if (rests.length > 0) {
        lstBack = setSHuffledRandom(rests, lstBack)
    }

    return lstBack;
}


const setSHuffled = (rests, lstBack) => {
    let randomIndex = Math.floor(Math.random() * rests.length);
    lstBack.push(rests[randomIndex]);
    rests.splice(randomIndex, 1);
    if (rests.length > 0) {
        lstBack = setSHuffled(rests, lstBack)
    }

    return lstBack;
}


//שדה מובייל וזוגו הקיים (תמיד מתפרש כדסקטופ) עם נפילה מובייל->דסקטופ, ואז עמוד->מאסטר
const resolveMobiDesk = (curPage, master, mobiOrNot, desktopField, mobileField) => {
    let pageVal = (mobiOrNot && curPage && curPage[mobileField]) ? curPage[mobileField] : (curPage && curPage[desktopField]);
    if (pageVal != null && pageVal !== "") return pageVal;
    return (mobiOrNot && master && master[mobileField]) ? master[mobileField] : (master && master[desktopField]);
}

//לעמוד החיפוש אין רשומת עמוד - בונים לו "עמוד" משדות החיפוש שבמאסטר,
//כך ש-setTheImgWait מטפל בו כמו בכל עמוד (שדה ריק נופל לערך המאסטר הכללי)
const searchWaitPage = (master) => ({
    waitingImg: master?.searchWaitingImg,
    waitingImgMobile: master?.searchWaitingImgMobile,
    waitingImgMore: master?.searchWaitingImgMore,
    waitingImgMobileMore: master?.searchWaitingImgMobileMore,
    imgSize: master?.searchImgSize,
    imgSizeMobile: master?.searchImgSizeMobile,
});

//---- תמונות המתנה מרובות: בכל כניסה לעמוד מוצגת אחת באקראי ----

//התמונה הראשית + הנוספות, בלי ריקים
const waitImgsList = (mainImg, moreImgs) => [mainImg, ...(Array.isArray(moreImgs) ? moreImgs : [])].filter(Boolean);

//העמוד קורא ל-setTheImgWait כמה פעמים בזמן הטעינה (בעלייה ואחרי שהנתונים מגיעים).
//כדי שהתמונה לא תתחלף באמצע ההמתנה, אותה רשימה באותו עמוד מחזירה את אותה בחירה
let lastWaitPick = { key: "", img: "", at: 0 };
const WAIT_PICK_KEEP_MS = 15000;

//לתמונות המאסטר בוחרים מראש את התמונה הבאה וטוענים רק אותה ברקע, כך שבעמוד
//הבא היא כבר בזיכרון הדפדפן. לא טוענים את כל הרשימה - חבל על הגלישה בסלולר
const NEXT_MASTER_WAIT_KEY = "nextMasterWaitIdx";
const prefetchNextWaitImg = (list, curIdx) => {
    let nextIdx = Math.floor(Math.random() * (list.length - 1));
    if (nextIdx >= curIdx) nextIdx++;
    try { sessionStorage.setItem(NEXT_MASTER_WAIT_KEY, String(nextIdx)); } catch (e) { }
    setTimeout(() => preloadWaitImg(`${ConnUrls.servMediasUrl}${list[nextIdx]}`), 1500);
}

//תמונות המתנה שכבר נטענו בדפדפן (ל-WaitImgOverlay ול-splash ב-App.js)
const loadedWaitUrls = new Set();
const waitImgLoaded = (url) => loadedWaitUrls.has(url) || (!!url && activeSplashPick()?.loaded === true && activeSplashPick().url === url);

//התמונה שה-splash של index.html בחר (window.amSplashPick). בעמוד הראשון שנפתח
//(לפני כל ניווט) שכבת ההמתנה ממשיכה אותה באותו גודל, כדי שהמעבר לא יורגש
const activeSplashPick = () => (window.amSplashPick && isFreshPageLoad()) ? window.amSplashPick : null;

//המאסטר הגיע - שומרים בדפדפן כמה תמונות splash יש ובאיזה גודל, בשביל index.html
//בכניסה הבאה. מאסטר בלי השדות (לפני splash מרובה) - מוחקים, ו-index.html נופל ל-key הישן
const saveSplashCfg = (master) => {
    if (!master) return;
    try {
        if (master.splashScreenCountMobile == null && master.splashScreenCountDesktop == null) {
            localStorage.removeItem("amSplash");
            return;
        }
        localStorage.setItem("amSplash", JSON.stringify({
            Mobile: { n: master.splashScreenCountMobile || 0, size: master.splashImgSizeMobile || master.splashImgSize || "" },
            Desktop: { n: master.splashScreenCountDesktop || 0, size: master.splashImgSize || "" },
        }));
    } catch (e) { }
}
const preloadWaitImg = (url, onDone) => {
    if (!url) return;
    if (loadedWaitUrls.has(url)) { onDone && onDone(); return; }
    try {
        const im = new Image();
        im.onload = () => { loadedWaitUrls.add(url); onDone && onDone(); };
        im.onerror = () => { onDone && onDone(); };
        im.src = url;
    } catch (e) { onDone && onDone(); }
}

//מפת תמונות ההמתנה של כל העמודים לפי נתיב (השרת: DTechComp/waitImgsMap.js). בזמן
//שהעמוד מחכה לנתונים שלו, WaitImgOverlay מציג לפיה את התמונה של העמוד, ובחירת
//האקראי נשמרת (lastWaitPick), כך שכשהנתונים מגיעים ממשיכה אותה תמונה.
//null = המפה עוד לא הגיעה. עמוד שלא במפה = אין לו תמונה משלו, נופל למאסטר
let waitImgsMap = null;
let waitMapListeners = [];
const setWaitImgsMap = (map) => {
    waitImgsMap = map || {};
    waitMapListeners.forEach(cb => cb());
    waitMapListeners = [];
}
//מחזיר פונקציית ביטול, לשימוש ב-useEffect
const onWaitMapReady = (cb) => {
    if (waitImgsMap) return () => { };
    waitMapListeners.push(cb);
    return () => { waitMapListeners = waitMapListeners.filter(c => c !== cb) };
}
const waitPageFromMap = () => {
    if (!waitImgsMap) return null;
    let path = window.location.pathname;
    try { path = decodeURIComponent(path); } catch (e) { }
    return waitImgsMap[path] || {};
}

//נקרא כשהמאסטר מגיע, עוד לפני נתוני העמוד: בוחר כבר עכשיו את תמונת המאסטר
//(הבחירה נשמרת ב-lastWaitPick, כך שהעמוד יקבל בדיוק אותה) ומתחיל להוריד אותה.
//עמוד עם תמונה משלו ממשיך לבחור משלו - אז ההורדה הזו לא בשימוש בעמוד הזה
const preloadMasterWait = (master, mobiOrNot) => {
    if (!master || master.imgWaitingActive === false || activeSplashPick()) return;
    let img = pickWaitImg(master.waitingImgMaster, master.waitingImgMasterMore, master.waitingImgMasterMobile, master.waitingImgMasterMobileMore, mobiOrNot, true);
    if (img) preloadWaitImg(`${ConnUrls.servMediasUrl}${img}`);
}

//רשימת המובייל אם יש, אחרת של הדסקטופ. כשהרשימות באותו אורך אותו אינדקס = אותה דמות
const pickWaitImg = (deskImg, deskMore, mobiImg, mobiMore, mobiOrNot, isMaster) => {
    let list = waitImgsList(deskImg, deskMore);
    if (mobiOrNot) {
        let mobiList = waitImgsList(mobiImg, mobiMore);
        if (mobiList.length) list = mobiList;
    }
    if (list.length <= 1) return list[0] || "";

    let pickKey = `${window.location.pathname}|${list.join(",")}`;
    if (lastWaitPick.key === pickKey && Date.now() - lastWaitPick.at < WAIT_PICK_KEEP_MS) {
        return lastWaitPick.img;
    }

    let idx = Math.floor(Math.random() * list.length);
    if (isMaster) {
        let saved = NaN;
        try { saved = parseInt(sessionStorage.getItem(NEXT_MASTER_WAIT_KEY)); } catch (e) { }
        if (saved >= 0 && saved < list.length) idx = saved;
        prefetchNextWaitImg(list, idx);
    }

    lastWaitPick = { key: pickKey, img: list[idx], at: Date.now() };
    return list[idx];
}

const setTheImgWait = (curPage, master, mobiOrNot) => {

    if (master && master.imgWaitingActive === false) {
        return ({ active: false });
    }

    //העמוד הראשון אחרי ה-splash - אותה תמונה ואותו גודל, וההשהיה של העמוד
    let splash = activeSplashPick();
    if (splash) {
        let imgDelay = resolveMobiDesk(curPage, master, mobiOrNot, "imgDelay", "imgDelayMobile");
        let backgroundSize = (!splash.size || splash.size === "full") ? "cover" : `${splash.size}%`;
        return ({ imgDelay, waitImg: splash.img, imgBackPos: 'center', backgroundSize, backgroundRepeat: 'no-repeat', imgWaitingSpecial: "", active: true });
    }

    let hasPageImg = curPage.waitingImg != null && curPage.waitingImg != "";

    let waitImg = "";
    let imgWaitingSpecial = "";

    if (hasPageImg) {
        //תמונת דסקטופ של העמוד היא ברירת המחדל - השדה הקיים waitingImg תמיד
        //מתפרש כתמונת דסקטופ, גם ברשומות ישנות שנוצרו לפני הפרדת מובייל/דסקטופ
        waitImg = pickWaitImg(curPage.waitingImg, curPage.waitingImgMore, curPage.waitingImgMobile, curPage.waitingImgMobileMore, mobiOrNot, false);
        imgWaitingSpecial = "imgWaitingSpecial"
    }
    else {
        waitImg = pickWaitImg(master.waitingImgMaster, master.waitingImgMasterMore, master.waitingImgMasterMobile, master.waitingImgMasterMobileMore, mobiOrNot, true);
    }

    let imgDelay = resolveMobiDesk(curPage, master, mobiOrNot, "imgDelay", "imgDelayMobile");

    let imgSize = resolveMobiDesk(curPage, master, mobiOrNot, "imgSize", "imgSizeMobile");
    let backgroundSize = (!imgSize || imgSize === "full") ? "cover" : `${imgSize}%`;

    return ({ imgDelay, waitImg, imgBackPos: 'center', backgroundSize, backgroundRepeat: 'no-repeat', imgWaitingSpecial, active: true });
}

const searchMe = (txtSearch, searchList) => {
    txtSearch = (txtSearch == null) ? "" : txtSearch.trim();
    let lstBack = [];

    if (txtSearch != "") {
        let theLstBack = searchList.map((itm, index) => {

            if (itm.buissName.includes(txtSearch)) {
                if (lstBack.findIndex(ls => ls._id == itm._id) == -1) {
                    lstBack = [...lstBack, itm];
                }
            }
            else {

                itm.buisMenu.map((mnuItm, mnuItmIndex) => {
                    if (mnuItm.DivName.includes(txtSearch)) {
                        if (lstBack.findIndex(ls => ls._id == itm._id) == -1) {
                            lstBack = [...lstBack, itm];
                        }
                    }
                    else {
                        mnuItm.Products.map((mnuItmProd, mnuItmProdIndex) => {
                            if (mnuItmProd.prodName.includes(txtSearch)) {
                                if (lstBack.findIndex(ls => ls._id == itm._id) == -1) {
                                    lstBack = [...lstBack, itm];
                                }
                            }
                        })
                    }

                })

            }
        })

        return lstBack;
    }
    else {

        return searchList;
    }
}

//מתייחס לרשימות צ'ק בוקסס 
//בודק כמה פריטים נבחור עד כה ברשימה המתקבלת
const getTotalSelected = (theLst) => {
    let counting = 0;

    if (theLst && theLst.length > 0) {
        theLst.forEach((item, index) => {
            counting += item.itmsMount;
        });
    }

    return counting
}

//מתייחס לרשימות צ'ק בוקסס 
//בודק אם הרשימה עברה את המקסימום
const chkIfPasdMax = (maxSelection, selectedCounting) => {
    maxSelection = maxSelection > 0 ? maxSelection : 500

    if (maxSelection > selectedCounting) {

        return false;
    }
    else {

        return true;
    }


}



const validPhone = (phone) => {
    if (phone && phone !== "") {
        var clearPhone = phone.replace('-', '');
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (!pattern.test(clearPhone)) {
            return false
        } else if (clearPhone.length != 10 && clearPhone.length != 9) {
            return "<p>יש להזין מספר טלפון תקין</p>";
        }
        else {
            return "";
        }
    }
    else {
        return "<p>יש להזין מספר טלפון תקין</p>";
    }
}

const validEmail = (email) => {
    if (email !== "") {
        var pattern = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        if (!pattern.test(email)) {
            return "<p>יש להזין כתובת מייל תקינה<p>";
        }
        else {
            return "";
        }
    }
    else {
        return "<p>יש להזין כתובת מייל תקינה<p>";
    }
}


const getOnlyaddress = (props) => {

    let enter = (props.address?.ent != null) ? props.address?.ent + " " : "";

    let mainAddress = props.address?.street + " " + props.address?.num + " " + enter + props.address?.city;

    return (
        { mainAddress }
    );
}


//טקסטי הרצועה שמוצגת על כרטיס העסק.
//מיוצאים כקונסטנטות כדי שההשוואות בצד המציג יהיו מול אותו מקור -
//קודם היו כאן שתי גרסאות של "עמוס, רק איסופים", עם ובלי רווח,
//וההשוואה ב-RestaurantPage תפסה רק אחת מהן
const STRIP_CLOSED_NOW = "סגור כעת";
const STRIP_CLOSED_FUTURE_ONLY = "סגור כעת, ניתן לבצע הזמנה עתידית";
const STRIP_ONLY_PICKUP = "כרגע רק איסופים";
//עסק שמאפשר הזמנת שולחן ואי אפשר להזמין ממנו אוכל.
//"עמוס" נשמר למצב שבו העסק פתוח ופשוט מוצף בהשהיות -
//כשהוא סגור לפי שעות זה לא עומס
const STRIP_RESERV_ONLY = "הזמנות שולחן בלבד";
const STRIP_BUSY_RESERV_ONLY = "עמוס, הזמנות שולחן בלבד";

//מחזיר את טקסט הרצועה לפי מה שאפשר להזמין בפועל.
//
//chans הוא הפלט של MyDateTime.resolveBusinessChannels.
//הרצועה נגזרת מ-takeAwayOk / deliveryOk ולא משעות הפתיחה -
//עסק יכול להיות מסומן "פתוח" ובכל זאת בלי אפשרות להזמין,
//וזו בדיוק הרצועה שמסבירה זאת ללקוח.
//
//הניסוח גנרי בכוונה: שמות ימים חריגים לא נחשפים ללקוח
//בודק אם הזמנה עתידית באמת זמינה לעסק הזה עכשיו (לצורך טקסט הרצועה בלבד -
//לא בדיקת slot ספציפי, זו מתבצעת בהמשך ע"י MyDateTime.isFutureSlotValid).
//"סגור עד שנפתח שוב" (delaydVal="8") לערוץ מסוים חוסם הזמנות עתידיות
//לאותו ערוץ, כי זו החלטה ידנית מפורשת של העסק לעצור לגמרי, לא שעות רגילות.
const futureOrderAvailable = (rest, master) => {
    if (!rest?.futureOrdersEnabled) return false;
    if (master?.masterFutureOrders?.block) return false;
    const deliveryClosedIndef = rest.closeDeliverDelay?.delaydVal === "8";
    const takeAwayClosedIndef = rest.closeTakeDelay?.delaydVal === "8";
    //ברירת המחדל בסכמה היא true - מסמכים ישנים שנוצרו לפני הוספת השדה
    //עשויים להיות undefined ולא false, ולכן !== false ולא בדיקת אמת ישירה
    const deliveryFutureOk = rest.futureOrdersDelivery !== false && !deliveryClosedIndef;
    const takeAwayFutureOk = rest.futureOrdersTakeAway !== false && !takeAwayClosedIndef;
    return !!(deliveryFutureOk || takeAwayFutureOk);
}

const notGettinOrders = (master, item, chans) => {

    if (!chans || !item) return "";

    //סגירה יזומה כללית במאסטר - חסימת חירום גורפת, לא מציעים הזמנה עתידית
    if (master?.blockDeliverys?.block && master?.blockPickUps?.block) {
        return STRIP_CLOSED_NOW;
    }

    //אין אף ערוץ פעיל
    if (!chans.canOrderNow) {
        return futureOrderAvailable(item, master) ? STRIP_CLOSED_FUTURE_ONLY : STRIP_CLOSED_NOW;
    }

    //רק איסופים אפשריים
    if (chans.takeAwayOk && !chans.deliveryOk) {
        return STRIP_ONLY_PICKUP;
    }

    //רק משלוחים, או שניהם - בלי רצועה
    return "";
}

//טקסט הפס התחתון בדף העסק, לעסק שמאפשר הזמנת שולחן.
//
//מחזיר "" כשלא רלוונטי - כלומר העסק לא מאפשר הזמנת שולחן,
//או שכן אפשר להזמין ממנו אוכל. במקרים האלה הפס נקבע כרגיל.
//
//הבחנה בין שני הנוסחים: "עמוס" רק כשהעסק פתוח לפי שעות הפתיחה
//ושתי ההשהיות פעילות - כלומר המקום עובד ופשוט מוצף.
//בכל סיבה אחרת (מחוץ לשעות הערוצים, יום חריג, חסימה במאסטר,
//מתגים כבויים, לא אונליין) הנוסח הוא בלי "עמוס".
const reservationOnlyStrip = (master, item, chans) => {

    if (!item || item.buisReservation !== true) return "";

    //עסק שלא מקבל הזמנות אונליין בכלל.
    //resolveBusinessChannels לא בודק buissIsOnline, ולכן זה לא
    //משתקף ב-canOrderNow וצריך בדיקה מפורשת. זה לא עומס
    if (item.buissIsOnline === false) return STRIP_RESERV_ONLY;

    if (!chans || chans.canOrderNow) return "";

    const deliveryDelayed = !!(item.closeDeliverDelay &&
        item.closeDeliverDelay.delaydVal &&
        item.closeDeliverDelay.delaydVal !== "0");

    const takeawayDelayed = !!(item.closeTakeDelay &&
        item.closeTakeDelay.delaydVal &&
        item.closeTakeDelay.delaydVal !== "0");

    const buisOpenNow = !!(chans.business && chans.business.openOrCLose);

    if (deliveryDelayed && takeawayDelayed && buisOpenNow) {
        return STRIP_BUSY_RESERV_ONLY;
    }

    return STRIP_RESERV_ONLY;
}

//בודק אם יש הגדרת שינוי זמן משלוח/איסוף לכלל העסקים במאסטר - channel="Take" בוחר
//בשדות הנפרדים של איסוף (timingTakeAway/minTimingTakeAway), אחרת (ברירת מחדל) במשלוח
const checkForDeliverysDelay = (master, buissTiming, channel) => {
    const timingField = channel === "Take" ? master.timingTakeAway : master.timingDeliverys;
    const minTimingField = channel === "Take" ? master.minTimingTakeAway : master.minTimingDeliverys;
    if (timingField && timingField > 0) {
        return (timingField > parseInt(buissTiming)) ?
            timingField : buissTiming;
    }
    else if (minTimingField && minTimingField > 0) {
        return (parseInt(buissTiming) + minTimingField);
    }
    else {
        return buissTiming;
    }

}

//ממיין: אפשר להזמין -> אפשר חלקית -> סגור.
//המיון לפי canOrderNow ולא לפי שעות הפתיחה, כי זה מה שמעניין
//את הלקוח. התווית הירוקה/אדומה על הכרטיס עדיין לפי שעות הפתיחה,
//ולכן כרטיס יכול להיות בעל נקודה ירוקה וממוין אחרון - זה מכוון
// ממיין רשימת עסקים כך שהפתוחים ראשונים, אח"כ פתוחים-חלקית, אח"כ סגורים.
// בתוך כל קבוצה: העסקים הקבועים (isFixed) נשמרים בסדר שנקבע ידנית (באדמין),
// לפני שאר העסקים שעוברים ערבוב אקראי.
// isFixed - פונקציה אופציונלית (item) => boolean המזהה עסק קבוע. ברירת מחדל: אין קבועים.
const getShufBuissClosAtLast = (lst, master = {}, isFixed = () => false) => {

    let closed = [];
    let opnes = [];
    let noOrders = [];
    lst.map((item, index) => {
        if (item !== undefined) {
            let chans = MyDateTime.resolveBusinessChannels(item, master);
            if (chans.canOrderNow) {
                //אפשר להזמין, אבל לא בכל הערוצים
                if (!chans.takeAwayOk || !chans.deliveryOk) {
                    noOrders.push(item)
                }
                else {
                    opnes.push(item)
                }
            }
            else {
                closed.push(item);

            }
        }
    })

    // בכל קבוצה: קבועים לפי סדרם המקורי, ואז השאר מעורבבים
    const orderGroup = (group) => {
        if (group.length === 0) return [];
        const fixed = group.filter(isFixed);
        const rest = group.filter((it) => !isFixed(it));
        const restShuffled = rest.length > 0 ? setSHuffled(rest, []) : [];
        return [...fixed, ...restShuffled];
    };

    // פתוח רק בחלק מהערוצים (למשל "רק משלוחים") לא יורד - רק סגור לגמרי (canOrderNow=false) בסוף
    let readylist = [];
    readylist = [...readylist, ...orderGroup([...opnes, ...noOrders])];
    readylist = [...readylist, ...orderGroup(closed)];

    return (readylist)
}

// דוחף סגורים לסוף הרשימה, בלי לגעת בסדר הפנימי (השרת כבר קבע אותו - fixed/random/הכל).
// stable partition בלבד: פתוחים, אח"כ פתוחים-חלקית, אח"כ סגורים - כל קבוצה בסדר שהתקבל.
// פתוח רק בחלק מהערוצים (למשל "רק משלוחים") נשאר במקומו - רק סגור לגמרי (canOrderNow=false) בסוף
const pushClosedToEnd = (lst, master = {}) => {
    let closed = [];
    let opnes = [];
    lst.forEach((item) => {
        if (item === undefined) return;
        let chans = MyDateTime.resolveBusinessChannels(item, master);
        if (chans.canOrderNow) {
            opnes.push(item);
        } else {
            closed.push(item);
        }
    });

    return [...opnes, ...closed];
}



const checkMsgDisplay = (msg) => {
    let bk = false;

    bk = msg.active;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // בדיקה 1: אם יש endDateTime → השעה בו עדיין לא עברה היום

    if (bk && msg.selectedDays && msg.selectedDays.length > 0) {

        let go = MyDateTime.getDayOfWeekLettersHebByNum(now.getDay());
        bk = msg.selectedDays.includes(go);
    }

    // בדיקה 2: אם יש startDateTime → השעה בו כבר עברה היום
    if (bk && msg.startDateTime) {
        const start = new Date(msg.startDateTime);
        const startMinutes = start.getHours() * 60 + start.getMinutes();

        if (startMinutes > currentMinutes) bk = false;
    }
    if (bk && msg.endDateTime) {

        const end = new Date(msg.endDateTime);
        const endMinutes = end.getHours() * 60 + end.getMinutes();

        if (endMinutes <= currentMinutes) bk = false;
    }
    // בדיקה 3: אם יש specificDateTime → התאריך בו הוא היום
    if (bk && msg.specificDateTime) {
        const spec = new Date(msg.specificDateTime);

        if (
            spec.getFullYear() !== now.getFullYear() ||
            spec.getMonth() !== now.getMonth() ||
            spec.getDate() !== now.getDate()
        ) {

            bk = false;
        }
    }
    return bk;
};

const checkMnuItemDisplay = (mnuItem) => {
    let bk = true;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // בדיקה 1: אם יש endDateTime → השעה בו עדיין לא עברה היום

    if (bk && mnuItem?.selectedDays && mnuItem?.selectedDays.length > 0) {

        let go = MyDateTime.getDayOfWeekLettersHebByNum(now.getDay());
        bk = mnuItem.selectedDays.includes(go);
    }

    // בדיקה 2: אם יש startDateTime → השעה בו כבר עברה היום
    if (bk && mnuItem?.startDateTime) {
        const start = new Date(mnuItem?.startDateTime);
        const startMinutes = start.getHours() * 60 + start.getMinutes();

        if (startMinutes > currentMinutes) bk = false;
    }
    if (bk && mnuItem?.endDateTime) {

        const end = new Date(mnuItem?.endDateTime);
        const endMinutes = end.getHours() * 60 + end.getMinutes();

        if (endMinutes <= currentMinutes) bk = false;
    }
    // בדיקה 3: אם יש specificDateTime → התאריך בו הוא היום
    if (bk && mnuItem?.specificDateTime) {
        const spec = new Date(mnuItem?.specificDateTime);

        if (
            spec.getFullYear() !== now.getFullYear() ||
            spec.getMonth() !== now.getMonth() ||
            spec.getDate() !== now.getDate()
        ) {

            bk = false;
        }
    }
    return bk;
};

//מחסנית משותפת של כל המודלים הפתוחים כרגע שמאזינים ל-Escape - כדי שלחיצת Escape
//תסגור תמיד רק את המודל העליון/האחרון שנפתח, ולא את כולם יחד כשיש מודלים מקוננים
let escapeStack = [];
let escapeListenerAttached = false;

const attachGlobalEscapeListener = () => {
    if (escapeListenerAttached) return;
    escapeListenerAttached = true;
    //שלב ה-capture (לא bubble) כדי לתפוס את Escape גם כשהמודל מקונן בתוך MUI Dialog,
    //שעוצר בעצמו את התפשטות Escape ב-bubble גם בלי onClose משלו
    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const top = escapeStack[escapeStack.length - 1];
        if (top) top();
    }, true);
};

//מאזין למקש Escape ומפעיל את אותה פונקציית סגירה שכפתור ה-X באותו מודל מפעיל
const useEscapeKey = (onEscape) => {
    const onEscapeRef = useRef(onEscape);
    onEscapeRef.current = onEscape;
    const isActive = typeof onEscape === 'function';

    useEffect(() => {
        attachGlobalEscapeListener();
        if (!isActive) return;
        const entry = () => { if (typeof onEscapeRef.current === 'function') onEscapeRef.current(); };
        escapeStack.push(entry);
        return () => {
            escapeStack = escapeStack.filter(e => e !== entry);
        };
    }, [isActive]);
};

// מכשיר מובייל אמיתי (טלפון/טאבלט) - לא לפי רוחב מסך כמו mobiOrNot, כדי שדפדפן דסקטופ
// בחלון צר לא ייחשב מובייל. כולל iPadOS שמדווח כ-Macintosh עם מסך מגע.
export const isMobileDevice = () => {
    const ua = navigator.userAgent;
    if (/Android|iPhone|iPad|iPod|Windows Phone/i.test(ua)) return true;
    return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
};

export const isNativeApp = () => {
    if (!!window.cordova) return true;
    const ua = navigator.userAgent;
    const isAndroidWebView = /Android/.test(ua) && /wv\)/.test(ua);
    const isIOSWebView = /iPhone|iPad|iPod/.test(ua) && !/Safari\//.test(ua);
    return isAndroidWebView || isIOSWebView;
};

// buissPhone הוא שדה טקסט חופשי במודל, ולפי החלטה תפעולית שמשתנה בין מסעדות מוזן בו
// לפעמים טקסט ("הזמנות דרך האתר בלבד") במקום מספר. מחזיר מספר מוכן לחיוג, או null אם
// אין שם מספר בכלל - ואז אסור להציג קישור לחיוג.
// תומך ב-052-6648248 וגם ב-+972526648248; הפלוס נשמר כי הוא משמעותי בחיוג בינלאומי.
// שים לב: להצגה למשתמש משתמשים בערך המקורי, לא בערך המוחזר מכאן.
export const getDiallable = (value) => {
    if (!value) return null;
    const raw = String(value).trim();
    const digits = raw.replace(/\D/g, '');
    if (digits.length < 7) return null;
    return raw.startsWith('+') ? `+${digits}` : digits;
};

// מה שמוצג למשתמש בשדה הטלפון של המסעדה. שלושה מצבים: מספר מוצג כמו שהוזן (עם
// המקפים), טקסט מוצג כמו שהוא, ושדה ריק מקבל את הכיתוב הזה - כי מסעדה בלי טלפון
// היא מסעדה שמקבלת הזמנות רק דרך האתר.
export const PHONE_EMPTY_TXT = 'הזמנות און ליין';

export const getPhoneDisplay = (value) => {
    const raw = value ? String(value).trim() : '';
    return raw === '' ? PHONE_EMPTY_TXT : raw;
};

// העתקה ללוח. execCommand קודם דווקא: הוא סינכרוני ולכן אפשר לדעת מיד אם הצליח
// ולהתאים את ההודעה, בעוד ש-Clipboard API מחזיר הבטחה ובתוך WebView גם עלול להידחות
// בלי הרשאה - ואז היינו אומרים "הועתק" בלי שכלום הועתק.
const copyToClipboard = (txt) => {
    try {
        const ta = document.createElement('textarea');
        ta.value = txt;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, txt.length);
        const ok = document.execCommand('copy');
        ta.remove();
        if (ok) return true;
    } catch (e) { }
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(txt);
            return true;
        }
    } catch (e) { }
    return false;
};

// הודעה קצרה בתחתית המסך, עם המספר בשורה נפרדת כדי שאפשר יהיה לקרוא אותו גם אם
// ההעתקה נכשלה
const showExtNote = (msg, number) => {
    const old = document.querySelector('.extLinkFallback');
    if (old) old.remove();
    const box = document.createElement('div');
    box.className = 'extLinkFallback';
    const txt = document.createElement('div');
    txt.textContent = msg;
    box.appendChild(txt);
    if (number) {
        const num = document.createElement('div');
        num.className = 'extLinkFallbackNum';
        num.textContent = number;
        box.appendChild(num);
    }
    document.body.appendChild(box);
    setTimeout(() => { try { box.remove(); } catch (e) { } }, 6000);
};

// פתיחת יעד חיצוני (whatsapp / tel / אתר) מתוך האפליקציה.
//
// למה באפליקציה לא מנסים בכלל לפתוח, לפי סדר הגילוי:
//   1. קישור ישיר whatsapp:// נותן ERR_UNKNOWN_URL_SCHEME. המעטפת לא מכירה סכמות
//      שאינן http ומנסה לטעון אותן בתוך ה-WebView.
//   2. ניווט אל https://wa.me נותן את אותו מסך שגיאה: הדף נטען, וה-JS שלו מפנה
//      הלאה אל whatsapp://.
//   3. עצירת הטעינה מונעת את מסך השגיאה, אבל הדיאלוג "פתח בוואטסאפ" לא עולה בכלל.
//   4. ה-userAgent הוא WebView חשוף של אנדרואיד ("wv", Version/4.0), בלי שום סימן
//      למעטפת שמטפלת בקישורים חיצוניים. הוא טוען הכל אצלו ולא מעביר כלום למערכת
//      ההפעלה, ולכן אין מסלול שבו וואטסאפ ייפתח - כל ניסיון רק מבזבז זמן למשתמש.
//
// לכן באפליקציה מעתיקים את המספר ללוח ואומרים את זה, כדי שהמשתמש יפתח את וואטסאפ
// בעצמו ויוכל להדביק. ההעתקה חייבת לרוץ ישירות בתוך ה-onClick, כי הדפדפן מרשה
// גישה ללוח רק בתוך מחווה של המשתמש.
//
// התיקון האמיתי הוא shouldOverrideUrlLoading בצד הנייטיב. כשהוא יהיה - אפשר יהיה
// למחוק את השכבה הזו ולהשאיר ניווט רגיל.
//
// ארבע שכבות:
//   0. האפליקציה מגרסה 1.0.11 - window.AshdodApp.openExternal פותח בחוץ (וואטסאפ / Waze / דפדפן)
//   1. דפדפן רגיל - פתיחה רגילה בטאב חדש, וואטסאפ נפתח לבד
//   2. Cordova עם cordova-plugin-inappbrowser - ה-API הרשמי, פותח בחוץ בלי סיבוכים
//   3. מעטפת בלי התוסף (הגרסאות הישנות של האפליקציה) - העתקה ללוח
export const openExternal = (url, copyValue, copiedMsg) => {
    if (openViaApp(url)) return;

    if (!isNativeApp()) {
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }

    if (window.cordova && window.cordova.InAppBrowser) {
        window.cordova.InAppBrowser.open(url, '_system');
        return;
    }

    if (!copyValue) return;

    if (copyToClipboard(copyValue)) {
        showExtNote(copiedMsg, copyValue);
    } else {
        showExtNote('לא הצלחנו להעתיק, זה המספר:', copyValue);
    }
};

export default {
    getShufBuissClosAtLast,
    pushClosedToEnd,
    setSHuffledRandom,
    setSHuffled,
    searchMe,
    sortAsc,
    setTheImgWait,
    searchWaitPage,
    preloadWaitImg,
    waitImgLoaded,
    preloadMasterWait,
    saveSplashCfg,
    setWaitImgsMap,
    onWaitMapReady,
    waitPageFromMap,
    getTotalSelected,
    chkIfPasdMax, connCheck,
    validPhone,
    checkToken,
    validEmail,
    getOnlyaddress,
    notGettinOrders,
    reservationOnlyStrip,
    futureOrderAvailable,
    STRIP_CLOSED_NOW,
    STRIP_CLOSED_FUTURE_ONLY,
    STRIP_ONLY_PICKUP,
    STRIP_RESERV_ONLY,
    STRIP_BUSY_RESERV_ONLY,
    checkForDeliverysDelay,
    checkMsgDisplay,
    checkMnuItemDisplay,
    useEscapeKey
};
